import { PrezemButton } from "components/ui/button";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { FetchOnlinePopupStores } from "services/online-popup-stores.service";
import dayjs from "dayjs";

const useOnlinePopupStores = () => {
  const navigate: NavigateFunction = useNavigate();
  const [filteredRows, setFilteredRows] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  
  const columns: GridColDef[] = [
    {
      field: 'actions',
      headerName: '',
      minWidth: 200,
      renderCell: (params) => (
        <div className="flex gap-2">
          <PrezemButton
            variant="outline"
            size="sm"
            onClick={() => {
              navigate(`/online-popup-stores/${params.id}`);
            }}
          >
            상세보기
          </PrezemButton>
          <PrezemButton variant="outline"
                        size="sm"
                        onClick={() => {
                          navigate(`/online-popup-stores/${params.id}/statistics`);
                        }}
          >
            통계
          </PrezemButton>
        </div>
      ),
    },
    {
      field: 'id',
      headerName: 'ID',
      minWidth: 80,
    },
    {
      field: 'name',
      headerName: '팝업명',
      minWidth: 200,
    },
    {
      field: 'slug',
      headerName: 'Slug',
      minWidth: 150,
    },
    {
      field: 'categories',
      headerName: '카테고리',
      minWidth: 150,
      renderCell: (params) => {
        const categories = params.value || [];
        return categories.join(', ');
      },
    },
    {
      field: 'startDate',
      headerName: '시작일',
      minWidth: 120,
      renderCell: (params) => {
        return dayjs(params.value).format('YYYY-MM-DD');
      },
    },
    {
      field: 'endDate',
      headerName: '종료일',
      minWidth: 120,
      renderCell: (params) => {
        return dayjs(params.value).format('YYYY-MM-DD');
      },
    },
    {
      field: 'playTime',
      headerName: '플레이 시간',
      minWidth: 100,
      renderCell: (params) => {
        return `${params.value}분`;
      },
    },
    {
      field: 'createdAt',
      headerName: '등록일',
      minWidth: 120,
      renderCell: (params) => {
        return dayjs(params.value).format('YYYY-MM-DD');
      },
    },
  ];

  const onClickAddNewOnlinePopupStore = () => {
    navigate('/online-popup-stores/new');
  };

  const fetchOnlinePopupStores = async () => {
    try {
      setLoading(true);
      const data = await FetchOnlinePopupStores();
      
      // operationPeriod 객체에서 startDate, endDate 추출하여 변환
      const transformedData = (data || []).map((item: any) => ({
        ...item,
        startDate: item.operationPeriod?.startDate,
        endDate: item.operationPeriod?.endDate,
      }));
      
      setFilteredRows(transformedData);
    } catch (error) {
      console.error('온라인 팝업스토어 목록 조회 실패:', error);
      setFilteredRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOnlinePopupStores();
  }, []);
  
  return {
    models: { columns, filteredRows, loading },
    operations: { onClickAddNewOnlinePopupStore, fetchOnlinePopupStores }
  };
};

export default function OnlinePopupStores() {
  const { models, operations } = useOnlinePopupStores();

  return (
    <div className="main-content">
      <div className="section-search">
        <div className="flex justify-end">
          <PrezemButton onClick={operations.onClickAddNewOnlinePopupStore}>
            + 팝업스토어 추가
          </PrezemButton>
        </div>
      </div>
      <div>
        <div style={{
               height: '80vh',
               width: '100%',
               marginTop: '10px',
             }}>
            <DataGrid
              rows={models.filteredRows}
              columns={models.columns}
              loading={models.loading}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 20 },
                },
              }}
              pageSizeOptions={[20, 50, 100]}
            />
        </div>
      </div>
    </div>
  );
}